"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryParseFloat = void 0;
/**
 * Parsuje kolejne wartości, zwracając pierwszą, której można przypisać wartość typu float
 *
 * @export
 * @param {...any[]} values
 * @returns {(number | undefined)}
 */
function tryParseFloat(...values) {
    for (let value of values) {
        if (typeof value === 'string') {
            value = value.replace(',', '.');
        }
        const parsedValue = parseFloat(value);
        if (!isNaN(parsedValue)) {
            return parsedValue;
        }
    }
}
exports.tryParseFloat = tryParseFloat;
//# sourceMappingURL=tryParseFloat.js.map